__turbopack_context__.v({
  "cityButton": "TdVnAa_cityButton",
  "cityItem": "TdVnAa_cityItem",
  "cityList": "TdVnAa_cityList",
  "cityName": "TdVnAa_cityName",
  "citySkeleton": "TdVnAa_citySkeleton",
  "citySlot": "TdVnAa_citySlot",
  "dialogBackdrop": "TdVnAa_dialogBackdrop",
  "dialogHost": "TdVnAa_dialogHost",
  "dialogHostDetached": "TdVnAa_dialogHostDetached",
  "dialogPopup": "TdVnAa_dialogPopup",
  "dialogPortalMount": "TdVnAa_dialogPortalMount",
  "dialogTitle": "TdVnAa_dialogTitle",
  "highlight": "TdVnAa_highlight",
  "postcode-city-skeleton-pulse": "TdVnAa_postcode-city-skeleton-pulse",
});
